<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 16/9/2020
  -->

<script>

import BaseComponent from "@/core/components/BaseComponent.vue";
import {Action} from "@/core/components/Dialogs/DialogActions";
import {ViewModeEnum} from "@/utils/helpers";


export default {
	extends: BaseComponent,
	name: "BaseQwoachDialog",

	props: {
		viewMode: ViewModeEnum,
		dataItem: {type: null, default: () => {}},
		closeOnClickOutside: {Boolean, default: true},
		title: {String, default: ""},
		okTitle: {String, default: ""},
		okButtonText: String,
		cancelTitle: {String, default: ""},
		showOk: {Boolean, default: true},
		showClose: Boolean,
		showCancel: {Boolean, default: true},
		showCancel2: {Boolean, default: false},
		showDelete: {Boolean, default: false},
		syncUrlParams: Object,
		onOkLoadingText: {String, default: "Saving..."},
		onDeleteLoadingText: {String, default: "Deleting..."},
		checkboxText: String,
		checkboxTooltipText: String,
		defaultCheckboxValue: Boolean,
		checkbox2Text: String,
		checkbox2TooltipText: String,
		defaultCheckbox2Value: Boolean,
		isOkEnabled: {type: Boolean, default: true},
	},

	data() {
		return {
			visibleData: true,
			closeHandled: false,
			action: Action.OK,
			isClosed: false,
			showProgressButtons: false,
			dialogLayout: null,
			onOkLoadingTextLocal: null,
			checkboxValue: null,
		}
	},

	async created() {
		let dialogTitle = this.analyticsDialogName()
		let eventName = `Dialog opened`
		let _ = this.trackEvent(eventName, {title: dialogTitle})
		// let _ = this.$analyticManager.trackPageView({title: "Dialog", ...this.analyticsPropsMethod()})
		if(typeof this.loadData === "function") {
			await this.handleAsync(this.loadData())
		}
	},

	async mounted() {
		await this.addSyncUrlParam()
	},

	beforeUnmount() {
		console.log("BaseQwoachDialog: beforeUnmount")
		this.removeSyncUrlParam()
	},


	methods: {

		async onBeforeCloseConfirm(closeCallback){
			console.log("BaseQwoachDialog: onBeforeCloseConfirm")
			if(this.closeOnClickOutside){
				closeCallback()
			}
		},

		analyticsDialogName(){
			return this.dialogTitle
		},

		async invalidateSyncUrlParam() {
			await this.addSyncUrlParam()
		},

		async addSyncUrlParam() {
			let syncUrlParam = this.getSyncUrlParams()
			if (!syncUrlParam) {
				return
			}

			await this.setQuery(syncUrlParam)
		},

		async removeSyncUrlParam() {
			let syncUrlParam = this.getSyncUrlParams() || {}
			// if (!syncUrlParam) {
			// 	return
			// }
			let queryKeys = Object.keys(syncUrlParam)
			let extraKeys = this.queryParamsToRemoveOnCloseInternal() || []
			queryKeys.push(...extraKeys)
			await this.removeSyncUrlParamInternal(queryKeys)
		},

		removeSyncUrlParamInternal(queryKeys){
			return this.removeQuery(queryKeys)
		},

		getSyncUrlParams() {
			return this.syncUrlParams
		},

		queryParamsToRemoveOnCloseInternal() {
			return this.queryParamsToRemoveOnClose()
		},

		queryParamsToRemoveOnClose() {
			return []
		},


		// async loadData() {
		//
		// },

		async onOk(data) {
			let isValid
			let actionMessage = this.getActionProgressMessage(Action.OK)

			this.progressDataLoading(actionMessage)
			try{
				isValid = await this.onBeforeOkInternal()
				this.hideProgress()
			}catch (error){
				isValid = false
				this.handleError(error)
			}
			console.log("onOk: isValid = ", isValid)
			if (isValid || isValid === undefined) {
				return await this.onAction(Action.OK, data)
			}
		},

		async onBeforeOkInternal(){
			// let res = this.performActionInternal("onBeforeOk")
			// if(res !== false){
				return this.onBeforeOk()
			// }
			// return false
		},

		async onBeforeOk() {
			return this.validateForm()
		},

		async onBeforeCancel() {
			return true
		},


		async onOkValidated() {
		},

		async onCancel() {
			this.progressDataLoading()
			let isValid = await this.onBeforeCancel()
			this.hideProgress()

			if (isValid) {
				return await this.onAction(Action.CANCEL, false)
			}
		},

		async onCancel2() {
			return await this.onAction(Action.CANCEL2, false)
		},

		async onDelete() {
		},

		async onAction(action, data, ...moreData) {
			console.log("onAction: action = ", action, ", data = ", data, ", moreData = ", ...moreData)
			let actionMessage = this.getActionProgressMessage(action)
			return await this.handleAsync(async () => {
				if (action !== Action.CANCEL && action !== Action.CANCEL2) {
					data = data || await this.createDataItem(data)
				}
				console.log("onAction2: action = ", action, ", data = ", data, ", moreData = ", ...moreData)
				this.action = action
				return await this.closeDialog(data, ...moreData)
			}, actionMessage)
		},

		async closeDialog(...data) {
			console.log("closeDialog: data = ", data)
			let result = await this.performAction(...data)
			// console.log("closeDialog: result = ", result)
			if (result === false || this.isClosed) {
				return
			}

			if(result === true){
				result = null //fallback to data if result is true
			}
			data = result ? [result] : data

			this.isClosed = true
			console.log("QwoachDialog close: action = ", this.action, ", data = ", data)
			let _ = this.$analyticManager.trackEvent(this.action, {context: this.analyticsEventActionName(), ...this.analyticsPropsMethod()})

			if (this.action === Action.DELETE) {
				this.$close()
			} else {
				this.$close(...data)
			}
		},

		analyticsEventActionName() {
			return "Dialog action clicked"
		},

		//this method is for legacy support
		async closeWithError(...data) {
			if (!this.isClosed) {
				this.isClosed = true
				this.$error(...data)
			}
		},

		findListenerByName(method) {
			if (method) {
				return this.findListenerByNameInternal(method) || (this.arguments && this.arguments[0] ? this.arguments[0][method] : null) //|| this[method]
			}
		},

		getItemName() {
			return null
		},

		analyticsPropsMethod() {
			return {
				category: "Dialog",
				dialog_title: this.dialogTitle,
				...(this.analyticsProps || {}),
				...this.analyticsPropsInternal()

			}
		},

		analyticsPropsInternal() {
			if (!this.dataItem) {
				return {}
			}
			return {
				item_id: this.dataItem.id,
				item_name: this.dataItem.name
			}
		},

		async performAction(...data) {
			return this.performActionInternal(this.action, ...data)
		},

		async performActionInternal(action, ...data) {
			let hasListener = this.findListenerByName(action) != null
			if (!hasListener) {
				action = action.replace("action", "on")
				hasListener = this.findListenerByName(action) != null
			}
			console.log("performAction: hasListener = ", hasListener, ", action = ", action)
			if (hasListener) {
				let actionMessage = this.getActionProgressMessage(action)
				console.log("actionMessage = ", actionMessage)
				// WARNING - the argument below must be a function and not a promise
				// so handleAsync first starts and only then evaluates the promise
				// this allows for additional flexibility like changing progressText
				// from inside the promise which will be overwritten by handleAsync otherwise
				return await this.handleAsync(() => this.emitPromise(action, ...data, this), actionMessage)
			}
		},

		getActionProgressMessage(action) {
			switch (action) {
				case Action.DELETE:
					return this.getDeleteLoadingText()
				case Action.OK:
					return this.getActionOkText
				default:
					return this.getActionText(action) || this.getActionOkText
			}
		},

		async createDataItem(data) {
			return data || this.dataItem
		},

		getActionText(action) {
			return this.getActionOkText
		},

		getDeleteLoadingText() {
			return this.onDeleteLoadingText
		},

		onCheckboxChanged(checkBoxValue){
			console.log("BaseQwoachDialog.onCheckboxChanged = ", checkBoxValue)
			this.checkboxValue = checkBoxValue
			this.emitPromise("onCheckboxChanged", checkBoxValue)
		},

		onCheckbox2Changed(checkBoxValue){
			console.log("BaseQwoachDialog.onCheckbox2Changed = ", checkBoxValue)
			this.checkbox2Value = checkBoxValue
			this.emitPromise("onCheckbox2Changed", checkBoxValue)
		},

	},

	computed: {
		getActionOkText() {
			return this.onOkLoadingTextLocal || this.onOkLoadingText
		},

		isAddMode() {
			return this.viewMode === ViewModeEnum.ADD
		},
		isEditMode() {
			return this.viewMode === ViewModeEnum.EDIT
		},
		isDeleteMode() {
			return this.viewMode === ViewModeEnum.DELETE
		},
		isViewMode() {
			return this.viewMode === ViewModeEnum.VIEW
		},

		// isViewModeAdd() {
		// 	return this.viewMode === ViewModeEnum.ADD
		// },

		canEdit() {
			return !this.isViewMode
		},

		// isViewModeView() {
		// 	return this.viewMode === ViewModeEnum.VIEW
		// },


		dialogTitle() {
			return this.title
		},

		okTitleComputed(){
			return this.okButtonComputed
		},
		okButtonComputed(){
			return this.okButtonText || this.okTitle || "Ok"
		},
		cancelTitleComputed(){
			return this.cancelButtonComputed
		},
		cancelButtonComputed(){
			return this.cancelTitle || "Cancel"
		},
		cancel2TitleComputed(){
			return this.cancel2Title || "Cancel"
		},

		showCloseComputed() {
			return this.showClose
		},
		showOkComputed() {
			return this.showOk
		},
		showDeleteComputed() {
			return this.showDelete
		},
		showCancelComputed() {
			return this.showCancel
		},
		showCancel2Computed() {
			return this.showCancel2
		},
		checkboxTextComputed(){
			return this.checkboxText
		},
		checkboxTooltipTextComputed(){
			return this.checkboxTooltipText
		},
		defaultCheckboxValueComputed(){
			return this.defaultCheckboxValue
		},
		checkbox2TextComputed(){
			return this.checkbox2Text
		},
		checkbox2TooltipTextComputed(){
			return this.checkbox2TooltipText
		},
		defaultCheckbox2ValueComputed(){
			return this.defaultCheckbox2Value
		},

		isOkEnabledComputed() {
			return this.isOkEnabled
		},





		dialogOkTitle() {
			return this.okTitleComputed
		},

		dialogCancelTitle() {
			return this.cancelTitleComputed
		},

		dialogCancel2Title() {
			return this.cancel2TitleComputed
		},

		dialogShowClose() {
			return this.showCloseComputed
		},
		dialogShowOk() {
			return this.showOkComputed
		},
		dialogShowDelete() {
			return this.showDeleteComputed
		},
		dialogShowCancel() {
			return this.showCancelComputed
		},
		dialogShowCancel2() {
			return this.showCancel2Computed
		},
		dialogCheckboxText(){
			return this.checkboxTextComputed
		},
		dialogCheckboxTooltipText(){
			return this.checkboxTooltipTextComputed
		},
		dialogDefaultCheckboxValue(){
			return this.defaultCheckboxValueComputed
		},
		dialogCheckbox2Text(){
			return this.checkbox2TextComputed
		},
		dialogCheckbox2TooltipText(){
			return this.checkbox2TooltipTextComputed
		},
		dialogDefaultCheckbox2Value(){
			return this.defaultCheckbox2ValueComputed
		},

		dialogIsOkEnabled() {
			return this.isOkEnabledComputed
		}

	}
}
</script>

<style>

</style>
